import { useWeb3Methods } from 'hooks/useWeb3Methods';
import { useWalletConnection } from 'hooks/useWalletConnection';
import React, { useEffect } from 'react';
import { useNetwork } from 'wagmi';
import { Wrapper } from './Main.styles';

interface MainProps {
  children: React.ReactNode;
}

export const Main = ({ children }: MainProps) => {
  const { getOnchainData } = useWeb3Methods();
  const { chain } = useNetwork();
  useWalletConnection();

  useEffect(() => {
    if (!chain?.unsupported) getOnchainData();
  }, []);

  return <Wrapper>{children}</Wrapper>;
};
